import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { FileService } from '../attachment-dialog/file.service';
import { Subject } from 'rxjs';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';
import { FileDownloadService } from '../../services/file-download.service';

@Component({
  selector: 'app-attach',
  templateUrl: './attach.component.html',
  styleUrls: ['./attach.component.scss'],
  standalone: false,
})
export class AttachComponent implements OnInit, OnChanges, OnDestroy {
  list: string[] = ['abc.jpg', 'def.jpg', 'ghi.jpg'];
  filesList: File[] = [];
  allFilesList1 = [];
  fileNameArray = [];
  editFileNameArray1 = [];
  bool: boolean;
  showAttachmentMode: boolean = false;
  showAttachment: boolean = false;
  multifileUpload: boolean;
  lastindex: number;
  fileMerge = [];
  filename = [];
  fileArray = [];
  deletedFile = [];
  newArrayfile: any;
  checked = false;
  fileDeleteSub = new Subject();
  key: number;
  multiSelectFlag: boolean = false;

  showAttachments = false;
  @Input() ModuleData: object;
  @Input() label: string;
  @Input() linkdownload: boolean;
  @Input() SendfileInput: object;
  @Input() toggleBtn: boolean = false;
  @Input() allowedTypes: string;
  @Output() fileOutput = new EventEmitter<object>();
  @Input() uploadType: string = 'multiple';
  @Input() editId: object;
  @Output() existingFile = new EventEmitter<object>();
  @Input() activityModuleFlag: boolean;
  @Input() viemMode: boolean = false;

  data1 = {
    // Required
    type: 'Attachment Icon', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '9', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  constructor(
    public dialog: MatDialog,
    private fileService: FileService,
    private _telemetryServices: TelemetryServices,
    private fileDownloadService: FileDownloadService
  ) {}

  ngOnInit() {
    // telemtry  API CALL and, send data

    this.data1.type = '';
    this.data1.subtype = 'Attachment Icon';
    this.data1.itype = 'AUTO';
    this.data1.stageto = 'Initial attachment page';
    if (this.data1) {
      this._telemetryServices.telemetryImpression(this.data1);
    }

    // this.showAttachmentMode = true;
    if (this.editId) {
      if (this.activityModuleFlag) {
        console.log(this.editId);
        this.fileService
          .getActivityFileData(this.editId['objectId'], this.editId['objectType'], this.editId['activityId'])
          .subscribe((res1) => {
            const obj = res1.ids;
            if (obj) {
              const mapped1 = Object.keys(obj).map((key) => ({ fileName: obj[key], fileID: key }));
              mapped1.forEach((element) => {
                // this.showAttachmentMode = true;
                this.showAttachments = true;
                this.checked = true;
                this.toggleBtn = true;
                this.editFileNameArray1.push({ fileName: element.fileName, fileID: element.fileID });
              });
            }
          });
      } else {
        this.fileService.getFileData(this.editId['objectId'], this.editId['objectType']).subscribe((res1) => {
          const obj = res1.ids;
          if (obj) {
            const mapped1 = Object.keys(obj).map((key) => ({ fileName: obj[key], fileID: key }));
            mapped1.forEach((elems) => {
              // this.showAttachmentMode = true;
              this.showAttachments = true;
              this.checked = true;
              this.toggleBtn = true;
              this.editFileNameArray1.push({ fileName: elems.fileName, fileID: elems.fileID });
            });
          }
        });
      }
    }
    const existingFileArray = this.editFileNameArray1;
    this.existingFile.emit({ existingFileArray });
  }

  openDialog() {
    const dialogRef = this.dialog.open(AttachmentDialogComponent, {
      width: '500px',
      data: {
        attachmentList: this.filesList,
        ModuleData: this.SendfileInput,
        allowedfileType: this.allowedTypes,
        uploadType: this.uploadType,
        editFileNameArray1: this.editFileNameArray1,
        existingFiles: this.fileNameArray,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const fileArrValues = [];
        //for single file
        if (this.uploadType == 'single') {
          this.allFilesList1.splice(0, this.allFilesList1.length);
          this.fileNameArray.splice(0, this.fileNameArray.length);
        }
        //For New Files
        result.forEach((fileValue) => {
          if (this.fileNameArray.indexOf(fileValue.name) === -1) {
            this.fileNameArray.push(fileValue.name);
            this.allFilesList1.push(fileValue);
          } else {
            this.allFilesList1.forEach((fileArr) => {
              if (fileValue.name != fileArr['name']) {
                fileArrValues.push(fileArr);
              }
            });
            //Override the last same name file
            delete this.allFilesList1;
            this.allFilesList1 = fileArrValues;
            this.allFilesList1.push(fileValue);
          }
        });

        if (this.editFileNameArray1) {
          //For Edit Files
          const editFileNameArray1Temp = [];
          const deletedFileTemp = [];

          this.editFileNameArray1.forEach((fileValue) => {
            // const res = result.filter(function (data) {
            result.filter(function (data) {
              if (data['name'] == fileValue.fileName) {
                deletedFileTemp.push(fileValue);
              } else {
                editFileNameArray1Temp.push(fileValue);
              }
            });
          });
          delete this.editFileNameArray1;
          this.editFileNameArray1 = editFileNameArray1Temp;
          if (deletedFileTemp && deletedFileTemp.length > 0) {
            //delete this.deletedFile;
            this.deletedFile = deletedFileTemp;
          }
        }

        this.onFileSelected(this.allFilesList1);
      }
    });
  }

  removeParent(closebtn, fileID) {
    const FileValuesDelete = [];
    this.filesList.forEach((fileValue) => {
      if (fileValue.name != fileID) {
        FileValuesDelete.push(fileValue);
      }
    });
    delete this.allFilesList1;
    this.allFilesList1 = FileValuesDelete;

    const FileValuesDeleteArray = [];
    this.fileNameArray.forEach((fileValue) => {
      if (fileValue != fileID) {
        FileValuesDeleteArray.push(fileValue);
      }
    });
    delete this.fileNameArray;
    this.fileNameArray = FileValuesDeleteArray;

    const fileMerge = this.allFilesList1;
    const deletedFile = this.deletedFile;
    this.fileOutput.emit({ fileMerge, deletedFile });
  }

  removeEditParent(closebtn, fileID) {
    const FileValuesDelete = [];
    this.editFileNameArray1.forEach((fileValue) => {
      if (fileValue.fileID != fileID) {
        FileValuesDelete.push(fileValue);
      } else {
        this.deletedFile.push(fileValue);
      }
      const fileMerge = this.allFilesList1;
      const deletedFile = this.deletedFile;
      this.fileOutput.emit({ fileMerge, deletedFile });
    });
    delete this.editFileNameArray1;
    this.editFileNameArray1 = FileValuesDelete;
  }

  downloadFile(fileID: any) {
    this.fileService.downloadFile(fileID).subscribe(
      async (res1) => {
        try {
          await this.fileDownloadService.downloadFileFromResponse(res1);
        } catch (error) {
          console.error('File download error:', error);
        }
      },
      (err) => {
        console.log(err);
        // this.error = err
      },
    );
  }

  //Multi Chunks
  onFileSelected(filesArray) {
    const files = filesArray;
    this.filename = [];
    this.fileMerge = [];
    const lastChunksize = 0;
    const chunkSize = 524288 * 10; //maximum 512 = 524,288, 256 = 262,144 B
    this.lastindex = files.length;
    this.key = 1;

    for (const file of files) {
      this.filename.push(file.name);
      if (this.uploadType == 'single' && this.filename.length > 0) {
        this.fileMerge.splice(0, this.fileMerge.length);
      }
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    }
    const _fileMerge = this.fileMerge;
    const _deletedFile = this.deletedFile;
    // this.fileOutput.emit({ fileMerge, deletedFile })
  }

  // uploadSingleFile(file,lastChunksize,chunkSize){
  //   this.replaceFile(this.filename[0].fileID);
  //     this.fileDeleteSub.subscribe(() =>{
  //       this.filename = [];
  //       //this.attachData = [];
  //       this.readFile(file, lastChunksize, this.myCallback.bind(this),chunkSize);
  //     })
  // }

  //  console.log('fileArray',this.fileArray)
  myCallback(file, lastChunksize, result, chunkSize) {
    lastChunksize = lastChunksize + chunkSize;
    if (result) {
      this.readFile(file, lastChunksize, this.myCallback.bind(this), chunkSize);
    } else {
      // if (this.uploadType == 'single') {
      const fileMerge = this.fileMerge;
      const deletedFile = this.deletedFile;
      this.fileOutput.emit({ fileMerge, deletedFile });
      // }
      ///end recursion
    }
  }

  readFile(file, lastChunksize: number, callback, chunkSize) {
    const fileBlob = file.slice(lastChunksize, lastChunksize + chunkSize);
    if (fileBlob.size != 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (_result) => {
        this.fileMerge.push(file);
        return callback(file, lastChunksize, fileReader.result, chunkSize);
      };
      fileReader.readAsText(fileBlob);
    } else {
      return callback(file, lastChunksize, false);
    }
  }

  // replaceFile(fileID){
  //   let observable =   this.fileService.deleteFile(fileID).subscribe(
  //       (res) => {
  //           let FileValuesDelete = [];
  //           this.filename.forEach(file => {
  //               if(file.fileID != fileID)
  //               {
  //                 FileValuesDelete.push(file);
  //               }
  //           });
  //           delete this.filename;
  //           this.filename = FileValuesDelete;
  //           //this.fileSizeError = '';
  //           this.fileService.setFileUploadEvent(this.filename);
  //           let observ = this.fileDeleteSub.observers[this.fileDeleteSub.observers.length-1];
  //           this.fileDeleteSub.observers.splice(0,this.fileDeleteSub.observers.length);
  //           this.fileDeleteSub.observers.push(observ);
  //           this.fileDeleteSub.next();
  //       },
  //       (err) => {
  //        // this.error = err
  //       }
  //     );
  // }

  ngOnChanges() {
    if (this.editId) {
      this.showAttachmentMode = true;
    }
  }

  ngOnDestroy() {
    // telemtry end call

    this.data1.subtype = 'Attachment Icon cleanup stage/end of page';
    this.data1.itype = 'AUTO';
    this.data1.stageto = 'destroy component,initial page';
    if (this.data1) {
      this._telemetryServices.telemetryEnd(this.data1);
    }
  }
}
